export const routes = {
  home: '/',
  huddVsTheOthers: '/hudd-vs-the-others',
  faq: '/faq',
};
